function scrollValidationErrorsIntoView(validationObserver) {
    //get errors from validationObserver
    const errors = Object.entries(validationObserver.refs)
        .map(([key, value]) => ({
            key,
            value
        }))
        .filter(error => {
            if (!error || !error.value || !error.value.failedRules) return false;
            return Object.keys(error.value.failedRules).length > 0;
        });

    //pick first error and scroll to it
    if (errors && errors.length > 0) {
        window.setTimeout(() => {
            validationObserver.refs[errors[0]['key']].$el.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }, 100);
    }
}

export function doValidation(validationObserver, validCallback, invalidCallback) {
    if (validationObserver) {
        validationObserver.validate().then((isValid) => {
            if (isValid) {
                if (validCallback) {
                    validCallback();
                }
            } else {
                scrollValidationErrorsIntoView(validationObserver);
                if (invalidCallback) {
                    invalidCallback();
                }
            }
        });
    } else {
        throw 'validationObserver is missing';
    }
}

export function getEnumOptions(enumsArray) {
    let res = [];
    enumsArray.forEach(function (enumVal) {
        res.push({ text: enumVal.text, id: enumVal.value })
    });
    return res;
}